export const ISSUE_TYPE_HELP_TEXT_URL = '/secure/ShowConstantsHelp.jspa?decorator=popup#IssueTypes';

export const ISSUE_TYPE_PICKER_ELEMENT_ID =
	'issue-create.ui.modal.create-form.type-picker.issue-type-select';
